import { render, staticRenderFns } from "./NavMenuItem.vue?vue&type=template&id=351aacd2&scoped=true&"
import script from "./NavMenuItem.vue?vue&type=script&lang=js&"
export * from "./NavMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./NavMenuItem.vue?vue&type=style&index=0&id=351aacd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351aacd2",
  null
  
)

component.options.__file = "NavMenuItem.vue"
export default component.exports